import { RouteType } from "types/RouteType";

const fieldOverviewRoutes: RouteType = {
  name: "Field Overview Dashboard",
  path: "/field-overview-dashboard",
  defaultParams: { tab: "dashboard" },
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./FieldReportingHeader"),
      title: "Field Overview Dashboard",
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./Dashboard/FieldReportingDashboard.Body"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async ({ rootStore }) => {
    // Load initial data for the module
    try {
      // Load jobs for filtering
      await (rootStore.jobStore as any).find({ query: { $limit: 100 } });

      // Load hardware orders
      await (rootStore.hardwareOrdersStore as any).find({
        query: { $limit: 100 },
      });

      // Load field activity issues
      await (rootStore.fieldActivityIssuesStore as any).find({
        query: { $limit: 100 },
      });

      // Load users for assignment
      if (rootStore.userStore) {
        await (rootStore.userStore as any).find({ query: { $limit: 100 } });
      }

      // Load teams for assignment
      if (rootStore.departmentTeamsStore) {
        await (rootStore.departmentTeamsStore as any).find({
          query: { $limit: 100 },
        });
      }

      // Load panels for issue location
      await (rootStore.panelStore as any).find({ query: { $limit: 500 } });

      return true;
    } catch (error) {
      console.error("Error loading field reporting data:", error);
      return false;
    }
  },
  onParamsChange: async ({ params, rootStore }) => {
    const tab = params?.tab || "dashboard";

    // Load specific data based on the active tab
    switch (tab) {
      case "panels":
        await (rootStore.panelStore as any).find({ query: { $limit: 500 } });
        break;
      case "hardware":
        await (rootStore.hardwareOrdersStore as any).find({
          query: { $limit: 500 },
        });
        await (rootStore.fieldActivityStore as any).find({
          query: { $limit: 500 },
        });
        break;
      case "dashboard":
      default:
        // Dashboard loads its own data through the store
        break;
    }
  },
  dialogs: [
    {
      name: "FieldActivityIssuesList",
      component: () => import("./Dialogs/FieldActivityIssuesList"),
      title: "Field Activity Issues",
      // onSubmit: async () => {
      //   // Dialog manages its own submission through the store
      //   return true;
      // },
      // onSubmitValidation: () => {
      //   // Validation handled internally by dialog
      //   return true;
      // },
      cancelButton: false,
      height: 700,
    },
    {
      name: "FieldActivityIssueView",
      component: () => import("./Dialogs/FieldActivityIssueView"),
      title: "Issue Details",
      // onSubmit: async () => {
      //   // View dialog doesn't submit
      //   return true;
      // },
      // onSubmitValidation: () => {
      //   return true;
      // },
      cancelButton: false,
      height: 700,
    },
    {
      name: "FieldActivityIssueForm",
      component: () => import("./Dialogs/FieldActivityIssueForm"),
      title: "Field Activity Issue",
      onSubmit: async ({ rootStore }) => {
        try {
          const store = (rootStore as any).fieldActivityIssuesViewStore;
          const success = await store.submitIssue();
          return success;
        } catch (error) {
          console.error("Error submitting field activity issue:", error);
          return false;
        }
      },
      onSubmitValidation: ({ rootStore }) => {
        const store = (rootStore as any).fieldActivityIssuesViewStore;
        return store.validateForm();
      },
      cancelButton: true,
      height: 650,
    },
    // TODO: Create dialog components
    /*{
      name: "FieldActivityForm",
      component: () => import("./Dialogs/FieldActivityForm"),
      title: "Add Field Activity",
      onSubmit: async ({ rootStore }) => {
        try {
          // TODO: Get formData from dialog state
          const formData = {}; // Replace with actual form data
          const activity = await (rootStore.fieldActivityStore as any).create(formData);
          
          // If associated with hardware order, create the relation
          // TODO: Handle hardwareOrderId from dialog context
          // if (dialogContext?.hardwareOrderId && activity.id) {
          //   await rootStore.fieldActivityHardwareOrderRelationStore.create({
          //     activityId: activity.id,
          //     hardwareOrderId: dialogContext.hardwareOrderId,
          //   });
          // }
          
          return true;
        } catch (error) {
          console.error("Error creating field activity:", error);
          return false;
        }
      },
      onSubmitValidation: ({ rootStore }) => {
        // TODO: Validate form data from dialog state
        return true; // Replace with actual validation
      },
      cancelButton: true,
      height: 500,
    },*/
    /*{
      name: "HardwareOrderForm",
      component: () => import("./Dialogs/HardwareOrderForm"),
      title: "Hardware Order",
      onSubmit: async ({ rootStore }) => {
        try {
          // TODO: Get formData and dialogContext from dialog state
          const formData = {}; // Replace with actual form data
          const dialogContext = {}; // Replace with actual dialog context
          // if (dialogContext?.hardwareOrderId) {
          //   // Edit existing hardware order
          //   await rootStore.hardwareOrdersStore.patch(dialogContext.hardwareOrderId, formData);
          // } else {
          //   // Create new hardware order
          //   await rootStore.hardwareOrdersStore.create(formData);
          // }
          return true;
        } catch (error) {
          console.error("Error saving hardware order:", error);
          return false;
        }
      },
      onSubmitValidation: ({ rootStore }) => {
        // TODO: Validate form data from dialog state
        return true; // Replace with actual validation
      },
      cancelButton: true,
      height: 600,
    },*/
  ],
};

// Additional routes for sub-pages
export const fieldReportingPanelsRoute: RouteType = {
  name: "Field Reporting Panels",
  path: "/field-reporting/panels",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./PanelTracking/PanelTrackingHeader"),
      title: "Panel Tracking",
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./PanelTracking/PanelTracking"),
      grayBackground: false,
    },
  },
  requiresPermission: false,
  beforeEnter: async ({ rootStore }) => {
    try {
      await (rootStore.panelStore as any).find({ query: { $limit: 1000 } });
      return true;
    } catch (error) {
      console.error("Error loading panels:", error);
      return false;
    }
  },
};

export const fieldReportingHardwareRoute: RouteType = {
  name: "Field Reporting Hardware",
  path: "/field-reporting/hardware",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./HardwareTracking/HardwareTrackingHeader"),
      title: "Hardware Tracking",
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./HardwareTracking/HardwareTracking"),
      grayBackground: false,
    },
  },
  requiresPermission: false,
  beforeEnter: async ({ rootStore }) => {
    try {
      await (rootStore.hardwareOrdersStore as any).find({
        query: { $limit: 1000 },
      });
      await (rootStore.fieldActivityStore as any).find({
        query: { $limit: 1000 },
      });
      await (rootStore.fieldActivityHardwareOrderRelationStore as any).find({
        query: { $limit: 1000 },
      });
      return true;
    } catch (error) {
      console.error("Error loading hardware data:", error);
      return false;
    }
  },
};

/*export const fieldActivityHistoryRoute: RouteType = {
  name: "FieldActivityHistory",
  path: "/field-reporting/hardware/:hardwareOrderId/activities",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./FieldActivityHistory/FieldActivityHistoryHeader"),
      title: "Activity History",
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./FieldActivityHistory/FieldActivityHistory"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ params, rootStore }) => {
    try {
      const hardwareOrderId = params?.hardwareOrderId;
      if (!hardwareOrderId) return false;
      
      // Load the specific hardware order
      await (rootStore.hardwareOrdersStore as any).get(hardwareOrderId);
      
      // Load related activities
      await (rootStore.fieldActivityHardwareOrderRelationStore as any).find({
        query: { hardwareOrderId },
      });
      
      // Load the actual activities
      await (rootStore.fieldActivityStore as any).find({ query: { $limit: 100 } });
      
      return true;
    } catch (error) {
      console.error("Error loading activity history:", error);
      return false;
    }
  },
};*/

export default fieldOverviewRoutes;
